import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "mwtn-favorites";

export default function useFavorites() {
  const [favorites, setFavorites] = useState<string[]>([]);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) setFavorites(parsed);
      }
    } catch {
      setFavorites([]);
    }
  }, []);

  const persist = useCallback((next: string[]) => {
    setFavorites(next);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch {
      /* storage unavailable, ignore */
    }
  }, []);

  const toggle = useCallback(
    (id: string) => {
      const isNowFavorite = !favorites.includes(id);
      const next = isNowFavorite
        ? [...favorites, id]
        : favorites.filter((item) => item !== id);
      persist(next);
      return isNowFavorite;
    },
    [favorites, persist],
  );

  const isFavorite = useCallback((id: string) => favorites.includes(id), [favorites]);

  return { favorites, toggle, isFavorite };
}